const types = {
	//Get Template name
	GET_CUSTOME_SURVEY_START: "GET_CUSTOME_SURVEY_START",
	GET_CUSTOME_SURVEY_SUCCESS: "GET_CUSTOME_SURVEY_SUCCESS",
	GET_CUSTOME_SURVEY_ERROR: "GET_CUSTOME_SURVEY_ERROR",
	GET_CUSTOME_SURVEY_RESET: "GET_CUSTOME_SURVEY_RESET",

	//Create Template name
	CREATE_CUSTOME_SURVEY_START: "CREATE_CUSTOME_SURVEY_START",
	CREATE_CUSTOME_SURVEY_SUCCESS: "CREATE_CUSTOME_SURVEY_SUCCESS",
	CREATE_CUSTOME_SURVEY_ERROR: "CREATE_CUSTOME_SURVEY_ERROR",
	CREATE_CUSTOME_SURVEY_RESET: "CREATE_CUSTOME_SURVEY_RESET",

	//delete Template name
	DELETE_CUSTOME_SURVEY_START: "DELETE_CUSTOME_SURVEY_START",
	DELETE_CUSTOME_SURVEY_SUCCESS: "DELETE_CUSTOME_SURVEY_SUCCESS",
	DELETE_CUSTOME_SURVEY_ERROR: "DELETE_CUSTOME_SURVEY_ERROR",
	DELETE_CUSTOME_SURVEY_RESET: "DELETE_CUSTOME_SURVEY_RESET",

	//update Template name
	UPDATE_CUSTOME_SURVEY_START: "UPDATE_CUSTOME_SURVEY_START",
	UPDATE_CUSTOME_SURVEY_SUCCESS: "UPDATE_CUSTOME_SURVEY_SUCCESS",
	UPDATE_CUSTOME_SURVEY_ERROR: "UPDATE_CUSTOME_SURVEY_ERROR",
	UPDATE_CUSTOME_SURVEY_RESET: "UPDATE_CUSTOME_SURVEY_RESET",

	//single item  name
	SINGLE_CUSTOME_SURVEY_START: "SINGLE_CUSTOME_SURVEY_START",
	SINGLE_CUSTOME_SURVEY_SUCCESS: "SINGLE_CUSTOME_SURVEY_SUCCESS",
	SINGLE_CUSTOME_SURVEY_ERROR: "SINGLE_CUSTOME_SURVEY_ERROR",
	SINGLE_CUSTOME_SURVEY_RESET: "SINGLE_CUSTOME_SURVEY_RESET",
};

export default types;
